export default __webpack_public_path__ + "static/arindamLehri11-5e12ab87d8e14c179822e9bc01139d1b.jpg";